import React from 'react'
import styled from 'styled-components'
import { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import { Snackbar } from '@mui/material';
import Loader from '../Loader';

const Container = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
position: relative;
z-index: 1;
align-items: center;
@media (max-width: 960px) {
    padding: 0px;
}
`

const Wrapper = styled.div`
position: relative;
display: flex;
justify-content: space-between;
align-items: center;
flex-direction: column;
width: 100%;
max-width: 1350px;
padding: 0px 0px 80px 0px;
gap: 12px;
@media (max-width: 960px) {
    flex-direction: column;
}
`

const Title = styled.div`
  font-size: 48px;
  text-align: center;
  font-weight: 800;
  margin-top: 20px;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #FFFFFF 0%, #FFFFFF 60%, #854CE6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  position: relative;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 8px 16px;
  border-radius: 12px;
  
  &:hover {
    background: linear-gradient(135deg, #FFFFFF 0%, #FFFFFF 40%, #FF6B6B 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    transform: translateY(-2px);
    
    &::after {
      background: linear-gradient(90deg, #FF6B6B, #ff8a8a);
      width: 80px;
    }
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, #854CE6, #FF6B6B);
    border-radius: 2px;
    transition: all 0.3s ease;
  }
  
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 36px;
  }
`;

const Desc = styled.div`
    font-size: 20px;
    text-align: center;
    max-width: 700px;
    color: ${({ theme }) => theme.text_primary};
    opacity: 0.8;
    line-height: 1.6;
    margin-bottom: 8px;
    font-weight: 400;
    
    @media (max-width: 768px) {
        font-size: 18px;
        max-width: 500px;
        margin-top: 12px;
    }
`;


const ContactForm = styled.form`
  width: 95%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, ${({ theme }) => theme.card} 0%, ${({ theme }) => theme.card_light} 100%);
  padding: 40px;
  border-radius: 20px;
  border: 1px solid rgba(133, 76, 230, 0.2);
  box-shadow: 0 16px 48px rgba(133, 76, 230, 0.15);
  backdrop-filter: blur(10px);
  margin-top: 32px;
  gap: 20px;
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #854CE6, #FF6B6B, #9d5ce8);
    opacity: 0.8;
  }
  
  &:hover {
    box-shadow: 0 20px 60px rgba(133, 76, 230, 0.2);
    transform: translateY(-4px);
    border-color: rgba(133, 76, 230, 0.3);
  }
  
  @media (max-width: 768px) {
    padding: 32px 24px;
    gap: 16px;
  }
`

const ContactTitle = styled.div`
  font-size: 28px;
  margin-bottom: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.text_primary};
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 24px;
  }
`

const ContactInput = styled.input`
  flex: 1;
  background: rgba(133, 76, 230, 0.05);
  border: 1px solid rgba(133, 76, 230, 0.2);
  outline: none;
  font-size: 16px;
  color: ${({ theme }) => theme.text_primary};
  border-radius: 12px;
  padding: 16px 20px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 400;
  
  &::placeholder {
    color: ${({ theme }) => theme.text_primary};
    opacity: 0.6;
  }
  
  &:focus {
    border: 1px solid #854CE6;
    background: rgba(133, 76, 230, 0.08);
    box-shadow: 0 0 0 3px rgba(133, 76, 230, 0.1);
    transform: translateY(-1px);
  }
  
  &:hover {
    border-color: rgba(133, 76, 230, 0.3);
    background: rgba(133, 76, 230, 0.07);
  }
`

const ContactInputMessage = styled.textarea`
  flex: 1;
  background: rgba(133, 76, 230, 0.05);
  border: 1px solid rgba(133, 76, 230, 0.2);
  outline: none;
  font-size: 16px;
  color: ${({ theme }) => theme.text_primary};
  border-radius: 12px;
  padding: 16px 20px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 400;
  resize: vertical;
  min-height: 120px;
  font-family: inherit;
  
  &::placeholder {
    color: ${({ theme }) => theme.text_primary};
    opacity: 0.6;
  }
  
  &:focus {
    border: 1px solid #854CE6;
    background: rgba(133, 76, 230, 0.08);
    box-shadow: 0 0 0 3px rgba(133, 76, 230, 0.1);
    transform: translateY(-1px);
  }
  
  &:hover {
    border-color: rgba(133, 76, 230, 0.3);
    background: rgba(133, 76, 230, 0.07);
  }
`

const ContactButton = styled.input`
  width: 100%;
  text-decoration: none;
  text-align: center;
  background: linear-gradient(135deg, #854CE6, #9d5ce8);
  padding: 16px 24px;
  margin-top: 8px;
  border-radius: 16px;
  border: none;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s ease;
  }
  
  &:hover {
    background: linear-gradient(135deg, #9d5ce8, #854CE6);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(133, 76, 230, 0.4);
    
    &::before {
      left: 100%;
    }
  }
  
  &:active {
    transform: translateY(0px);
  }
`



const Contact = () => {

  //hooks
  const [open, setOpen] = React.useState(false);
  const form = useRef();
  const [loading, setLoading] = useState(false); // Add loading state

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true); // Set loading to true when submitting

    emailjs.sendForm('service_tq7rqy1', 'template_lzus3ep', form.current, 'DdicUw29yGs6HtHSS')
      .then((result) => {
        setOpen(true);
        setLoading(false); // Reset loading state on success
        form.current.reset();
      }, (error) => {
        console.log(error.text);
        setLoading(false); // Reset loading state on error
      });
  }



  return (
    <Container>
      <Wrapper>
        <Title>Contact</Title>
        <Desc>Feel free to reach out to me for any questions or opportunities!</Desc>
        {loading ? ( // Show loader when loading
          <Loader />
        ) : (
          <ContactForm ref={form} onSubmit={handleSubmit}>
            <ContactTitle>Email Me 🚀</ContactTitle>
            <ContactInput placeholder="Your Email" name="from_email" />
            <ContactInput placeholder="Your Name" name="from_name" />
            <ContactInput placeholder="Subject" name="subject" />
            <ContactInputMessage placeholder="Message" rows="4" name="message" />
            <ContactButton type="submit" value="Send" />
          </ContactForm>
        )}
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={() => setOpen(false)}
          message="Your email has been sent successfully!"
          severity="success"
        />
      </Wrapper>
    </Container>
  )
}

export default Contact